import { render } from "./PopupHome.vue?vue&type=template&id=31573654&scoped=true"
import script from "./PopupHome.vue?vue&type=script&lang=js"
export * from "./PopupHome.vue?vue&type=script&lang=js"

import "./PopupHome.vue?vue&type=style&index=0&id=31573654&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31573654"]])

export default __exports__